var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full md:w-2/3 mt-4 md:mt-0 md:pl-8"},[_c('div',{staticClass:"w-full h-full padding--x chatbot__container py-4 md:pt-6 md:pb-4"},[_c('VueBotUI',{attrs:{"is-open":true,"messages":_vm.messages,"options":{
        colorScheme: 'rgb(242, 194, 68)',
        botTitle: this.chatBot.name,
        botAvatarImg: '/alfred.png',
      },"bot-typing":_vm.isTyping},on:{"msg-send":_vm.messageSendHandler}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }